(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    const filters = document.querySelector('.k24-collection__filter--container');
    const closeBtn = e.target.closest('#filters-close');

    if (closeBtn) {
      e.preventDefault();
      filters.classList.toggle('active');
      return;
    }else{
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MAX = 1024;

    function isMobile() {
      return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
    }

    function getHeader(el) {
      return el.closest('.k24-header');
    }

    function openPanel(el) {
      if (!el) return;
      el.classList.add('open');
    }

    function closePanel(el) {
      if (!el) return;
      el.classList.remove('open');
    }

    document.addEventListener('click', function (e) {
      if (!isMobile()) return;

      var header = getHeader(e.target);
      if (!header) return;

      var nav = header.querySelector('.k24-header__nav');
      if (!nav) return;

      // 1) Hele menu open/dicht
      var toggle = e.target.closest('#menu-toggle');
      if (toggle) {
        e.preventDefault();
        nav.classList.toggle('open');
        return;
      }

      // 2) Hele menu sluiten (kruisje in logo container, komt meerdere keren voor)
      var close = e.target.closest('#menu-close');
      if (close) {
        e.preventDefault();

        // sluit alle submenu's die open staan
        header.querySelectorAll('.sub-menu.open').forEach(function (sm) {
          closePanel(sm);
        });

        closePanel(nav);
        return;
      }

      // 3) Submenu open bij klik op hoofdmenu-item met sub-menu
      // Alleen top level: .k24-header__menu > nav > ul > li > a
      var topLink = e.target.closest('.k24-header__menu > nav > ul li a');
      if (topLink) {
        var li = topLink.closest('li');
        var sub = li ? li.querySelector(':scope > ul.sub-menu') : null;

        if (sub) {
          // heeft submenu: niet navigeren, maar submenu openen
          e.preventDefault();
          openPanel(sub);
        }
        return;
      }

      // 4) Submenu sluiten via .mega-menu-back (alle niveaus)
      var back = e.target.closest('.mega-menu-back');
      if (back) {
        e.preventDefault();
        var subMenu = back.closest('ul.sub-menu');
        closePanel(subMenu);
        return;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
